<template>
    <div class="content">
        <div class="content-head">
            <div class="content-head-title">搜索</div>
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="订单号">
                    <el-input v-model="params.orderssn" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="ERP订单号">
                    <el-input v-model="params.erporderssn" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="订单日期">
                    <el-date-picker v-model="params.date_start" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                    <span style="margin: 0 5px">至</span>
                    <el-date-picker v-model="params.date_end" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>
                <el-form-item label="业务员" v-if="isFiltration">
                    <el-input v-model="params.slaemanename" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="客户名称">
                    <el-input v-model="params.customername" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="工程名称" v-if="isFiltration">
                    <el-input v-model="params.projectname" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="还款倒计时" v-if="isFiltration">
                    <el-input v-model="params.minday" type="number" placeholder="" clearable class="el-select-mini"></el-input>
                    -
                    <el-input v-model="params.maxday" type="number" placeholder="" clearable class="el-select-mini"></el-input>
                </el-form-item>
                <el-form-item label="还款状态" v-if="isFiltration">
                    <el-select v-model="params.backstatus" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in backstatusOpt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getOrders_PayPLan(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh" :loading="loadingBtn">重置</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="setFiltration" :icon="!isFiltration ? 'el-icon-arrow-down' : 'el-icon-arrow-up'">
                        {{ !isFiltration ? '展开' : '收起' }}
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title">
                <span>计划列表</span>
                <el-dropdown trigger="click">
                    <el-button type="primary">
                        导出
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                            <span @click="getOrdersDistributetTransferExport()">导出结果订单</span>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <el-table :data="tableData" ref="table" @expand-change="handleExpandChange" :height="maxheight" style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">
                <el-table-column prop="Orders_ID" label="ID" align="center" width="100"></el-table-column>
                <el-table-column prop="Orders_SN" label="订单号" align="center"></el-table-column>
                <el-table-column prop="Orders_ERPSN" label="ERP订单号" align="center"></el-table-column>
                <el-table-column prop="Orders_Total_AllPrice" label="订单总额" align="center">
                    <template slot-scope="scope">￥ {{ scope.row.Orders_Total_AllPrice }}</template>
                </el-table-column>
                <el-table-column prop="totalpayed" label="还款总额" align="center">
                    <template slot-scope="scope">￥ {{ scope.row.totalpayed }}</template>
                </el-table-column>
                <el-table-column prop="" label="剩余总额" align="center">
                    <template slot-scope="scope">￥ {{ scope.row.Orders_Total_AllPrice - scope.row.totalpayed }}</template>
                </el-table-column>
                <el-table-column prop="Orders_Addtime" label="下单日期" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.Orders_Addtime | formatDate }}
                    </template>
                </el-table-column>
                <el-table-column prop="Orders_ProjectName" label="工程名称" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="OwnerName" label="绑定业务员" align="center"></el-table-column>
                <el-table-column type="expand" align="right">
                    <template v-slot="props">
                        <el-table :data="props.row.repaymentPlan" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                            <el-table-column prop="Distribute_BackDate" label="还款日期" align="center">
                                <template slot-scope="scope">
                                    {{ scope.row.Distribute_BackDate | formatDate }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="Distribute_BackAmount" label="还款金额" align="center"></el-table-column>
                            <el-table-column prop="totalpayed" label="已还款金额" align="center"></el-table-column>
                            <el-table-column prop="" label="剩余金额" align="center">
                                <template slot-scope="scope">
                                    {{ scope.row.Distribute_BackAmount - scope.row.totalpayed }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="totaldays" label="还款倒计时" align="center">
                                <template slot-scope="scope">{{ scope.row.totaldays }}天</template>
                            </el-table-column>
                            <el-table-column prop="amount" label="操作" align="center">
                                <template slot-scope="scope">
                                    <div class="operation-bar">
                                        <span class="operation-bar-block" @click="handleOpen(scope.row)">历史还款记录</span>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </template>
                </el-table-column>
                <el-table-column prop="totalamount" label="操作" align="center" width="80">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="toggleRepaymentPlan(scope.row)">还款计划</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>

        <el-dialog title="还款记录" :visible.sync="isDrawer" :before-close="handleClose" width="800px" :close-on-click-modal="false">
            <div>
                <el-table :data="historyList" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">
                    <el-table-column prop="Orders_Payment_DocNo" label="付款单号" align="center"></el-table-column>
                    <el-table-column prop="Orders_Payment_Amount" label="付款金额" align="center"></el-table-column>
                    <el-table-column prop="AuditStatus" label="审核状态" align="center"></el-table-column>
                    <el-table-column prop="Orders_Payment_Note" label="审核备注" show-overflow-tooltip align="center"></el-table-column>
                    <el-table-column prop="Orders_Payment_Addtime" label="付款时间" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.Orders_Payment_Addtime | formatDate }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
                <el-button @click="handleClose()">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue';
import { myMixin } from '@/utils/mixin.js';
import { toLowerCaseKeys } from '@/utils/utils.js';
export default {
    name: 'paymentplanManagement',
    mixins: [myMixin],
    components: {
        Pagination
    },
    data() {
        return {
            loadingBtn: false,
            isDrawer: false,
            params: {},
            expandedRowKeys: [],
            backstatusOpt: [
                { label: '全部', value: 0 },
                { label: '还款中', value: 1 },
                { label: '已还款', value: 2 }
            ],
            tableData: [],
            expandedRows: [],
            historyList: []
        };
    },
    mounted() {
        this.onRefresh();
    },
    methods: {
        /*
    重置查询
    */
        onRefresh() {
            (this.params = {
                backstatus: 0,
                maxday: 0,
                minday: 0,
                projectname: '',
                customername: '',
                slaemanename: '',
                erporderssn: '',
                orderssn: '',
                date_start: '',
                date_end: ''
            }),
                this.getOrders_PayPLan(true);
        },
        toggleRepaymentPlan(row) {
            // 切换当前行的展开状态
            row.isexpand = !row.isexpand;
            if (row.isexpand) {
                this.$newsApi.getOrders_PayPLanList({ OrdersID: row.Orders_ID }).then((res) => {
                    if (res.data.Resultcode == 0) {
                        row.repaymentPlan = res.data.data;
                        this.$refs.table.toggleRowExpansion(row);
                    }
                });
            }
        },
        handleExpandChange(row, expanded) {
            // 可以在这里监听行的展开/折叠变化
            console.log(row.isexpand, expanded);
        },
        /*
    列表查询
    */
        getOrders_PayPLan(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi
                .getOrders_PayPLan(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.tableData.forEach((item, index) => {
                            item.isexpand = false;
                            item.repaymentPlan = [];
                        });
                        this.paginationOptions.total = res.data.RecordCount;
                    } else {
                        this.tableData = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        getOrdersDistributetTransferExport() {
            alert('等待接口开发');
        },
        filteropt() {
            let params = { ...this.params };
            return { json: JSON.stringify(toLowerCaseKeys(params)), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getOrders_PayPLan();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getOrders_PayPLan();
        },
        handleOpen(items) {
            console.log(items, 'items');
            this.isDrawer = true;
            this.$newsApi.getOrdersPayPLanHistory({ PlanID: items.Distribute_ID }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.historyList = res.data.data;
                }
            });
        },
        handleClose() {
            this.isDrawer = false;
        }
    }
};
</script>

<style lang="scss">
/* 隐藏表格的默认箭头 */
.el-table__expand-icon {
    display: none; /* 隐藏默认的展开箭头 */
}
</style>
